import { FC } from 'react';
import { HomeDrawer } from './HomeDrawer';
import { useHistory, useLocation } from 'react-router-dom';
import { routePath } from 'Navigator/routes';
import { Link, IconButton } from '@material-ui/core';
import { ProfileAvatar } from './ProfileAvatar';
import classNames from 'classnames';
import { HomeDarkIcon, IstanbulDarkLogo, IstanbulWhiteLogo, HomeWhiteIcon, Container } from 'Components';
import { useLocalization } from 'Hooks';
import { routeIncludeCheck } from 'Utils';
import { userStore } from 'Stores/User';
import { useSelector } from 'react-redux';

import './DashboardHeader.scss';

type DashboardHeaderProps = {};

type DashboardHeaderMenuItemType = {
  title?: string;
  onClick?: () => void;
  isHomePage?: boolean;
  menuItemPath: string;
  itemID: string;
};

const DashboardHeader: FC<DashboardHeaderProps> = () => {
  const { pathname } = useLocation();

  const history = useHistory();
  const userData = useSelector(userStore);

  const isResetPassword = userData?.resetPassword;
  const isMiniApp = userData?.isMiniAppLogin;

  const {
    web_link_btn_kartlarim_homepage,
    web_link_btn_islemler_homepage,
    web_link_btn_kart_basvurusu_homepage,
    web_link_btn_gez_ve_harca_homepage,
    web_header_BUL,
  } = useLocalization();

  //TODO-menuItemPathler Routelar tamamen yazıldıktan sonra ona göre düzenlenecektir.

  const pushToHistory = (route: string) => {
    if (window.location.pathname !== route) {
      history.push(route);
    }
  };
  const menuItems: DashboardHeaderMenuItemType[] = [
    {
      onClick: () => pushToHistory(routePath.home),
      menuItemPath: routePath.home,
      itemID: 'navigateHomeBtnTest',
    },
    {
      title: web_link_btn_kartlarim_homepage,
      onClick: () => pushToHistory(routePath.cards),
      menuItemPath: routePath.cards,
      itemID: 'navigateCardsBtnTest',
    },
    {
      title: web_link_btn_islemler_homepage,
      onClick: () => pushToHistory(routePath.transactions),
      menuItemPath: routePath.transactions,
      itemID: 'navigateTransactionsBtnTest',
    },
    {
      title: web_link_btn_gez_ve_harca_homepage,
      onClick: () => pushToHistory(routePath.discover),
      menuItemPath: routePath.discover,
      itemID: 'navigateDiscoverBtnTest',
    },
    {
      title: web_link_btn_kart_basvurusu_homepage,
      onClick: () => pushToHistory(routePath.cardApplication),
      menuItemPath: routePath.cardApplication,
      itemID: 'navigateCardApplicationBtnTest',
    },
  ];

  const handleDirectHomePage = () => {
    if (isResetPassword) {
      return;
    }

    history.push(routePath.home);
  };

  const isHomePage = pathname === routePath.home;

  return (
    <header id="dashboardHeader">
      <div
        className={classNames({
          'dashboardHeader--blue': isHomePage,
          'dashboardHeader--white': !isHomePage,
        })}
      >
        <Container>
          <div className="dashboardHeader__logo--wrapper">
            <IconButton
              aria-label="Ana sayfaya git"
              onClick={handleDirectHomePage}
              className="dashboardHeader__logo--item"
              size="small"
            >
              {isHomePage ? <IstanbulWhiteLogo /> : <IstanbulDarkLogo />}
            </IconButton>
            <HomeDrawer />
            <ProfileAvatar isHomePage={isHomePage} />
          </div>
          <nav aria-label="Ana gezinim">
            <ul>
            {menuItems.map(({ title, onClick, menuItemPath, itemID }, index) =>
              (isMiniApp && itemID === 'navigateCardApplicationBtnTest') ||
              (web_header_BUL === '0' && itemID === 'navigateDiscoverBtnTest') ? (
                ''
              ) : (
                <MenuItem
                  key={index}
                  title={title}
                  onClick={isResetPassword ? undefined : onClick}
                  isIcon={index === 0}
                  isHomePage={isHomePage}
                  menuItemPath={menuItemPath}
                  itemID={itemID}
                />
              )
            )}
            </ul>
          </nav>
        </Container>
      </div>
    </header>
  );
};

export default DashboardHeader;

const MenuItem: FC<DashboardHeaderMenuItemType & { isIcon?: boolean }> = ({
  title,
  onClick,
  isIcon,
  isHomePage,
  menuItemPath,
  itemID,
}) => {
  const { pathname } = useLocation();
  const isActive = routeIncludeCheck(pathname, menuItemPath);

  return (
    <li>
      <Link
        id={itemID}
        href={menuItemPath}
        underline="none"
        onClick={(e) => { e.preventDefault(); onClick?.(); }}
        aria-label={isIcon ? 'Ana Sayfa' : undefined}
        aria-current={isActive ? 'page' : undefined}
        className={classNames({
          'dashboardHeader--white--activeLink': isActive,
        })}
      >
        {title && title}
        {isIcon && isHomePage && <HomeWhiteIcon aria-hidden="true" />}
        {isIcon && !isHomePage && <HomeDarkIcon aria-hidden="true" />}
      </Link>
    </li>
  );
};
